// @flow

import { RestClientAuthenticated } from '../network';
import { turanBaseURL } from '../../utils/urlUtils';
import type { ReconciliationStoreMapping } from '../../types/geminiType';

const reconciliationApi = {
  reconciliation: (pcId: string) => new RestClientAuthenticated(`${turanBaseURL()}/reconciliation/sc/${pcId}/stores`, 'GET').execute(),
  saveStoreMapping: (pcId: string, type: string, store: ReconciliationStoreMapping) =>
    new RestClientAuthenticated(`${turanBaseURL()}/reconciliation/sc/${pcId}/stores/mapping`, 'POST')
      .addParam('type', type)
      .jsonBody(store)
      .execute(),
};

export default reconciliationApi;
